import { SERVER_PREFIX } from "utils/config";
import { GZIP_FILE_EXTENSION } from "utils/files/mime";

export function getGraphQlFileUrl(
  url: string | null | undefined,
): string | undefined {
  if (!url) return;
  if (!url || /^(https?:)?\/\//.test(url)) return url;
  if (url.startsWith(SERVER_PREFIX)) return url;
  return `${SERVER_PREFIX}${url}`;
}

export function downloadFileUrl(url: string, filename?: string): void {
  const normalizedUrl = getGraphQlFileUrl(url);
  if (!normalizedUrl) return;

  const a = document.createElement("a");
  a.style.display = "none";
  a.href = normalizedUrl;
  a.download = filename || "true";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function splitExt(
  filename: string,
  maxExtLength?: number,
): [basename: string, extension?: string];
export function splitExt(
  filename: string | null | undefined,
  maxExtLength?: number,
): [basename: string | null | undefined, extension?: string];
export function splitExt(
  filename: string | null | undefined,
  maxExtLength = 5,
) {
  if (!filename) return [filename];

  const pieces = filename.split(".");

  if (pieces.length < 2) return [filename];

  const extPieces: string[] = [];

  if (pieces[pieces.length - 1] === GZIP_FILE_EXTENSION) {
    const gzExt = pieces.pop();
    if (gzExt) extPieces.unshift(gzExt);
  }

  const ext = pieces.pop();
  if (ext) extPieces.unshift(ext);

  if (!ext || ext.length > maxExtLength) return [filename];

  return [pieces.join("."), extPieces.join(".")];
}

export function getFileExtension(
  filename: string | null | undefined,
  maxLength?: number,
): string | undefined {
  const [, ext] = splitExt(filename, maxLength);
  return ext;
}
